/*
 * Filters values from set by a predicate function.
 */
function filter(set, predicate) {
    const filteredSet = new Set();
    for (const value of set) {
        if (predicate(value)) {
            filteredSet.add(value);
        }
    }
    return filteredSet;
}
/*
 * Checks if any value in set satisfies the predicate function.
 */
function some(set, predicate) {
    for (const value of set) {
        if (predicate(value)) {
            return true;
        }
    }
    return false;
}
/*
 * Checks if every value in set satisfies the predicate function.
 */
function every(set, predicate) {
    for (const value of set) {
        if (!predicate(value)) {
            return false;
        }
    }
    return true;
}
/*
 * Creates a new set that is the union of two sets.
 */
function union(setA, setB) {
    return new Set([...setA, ...setB]);
}
export const Sets = {
    filter,
    some,
    every,
    union,
};
//# sourceMappingURL=sets.js.map